import { Button, Form, Modal, TextArea } from '@mairistem/composants';
import React from 'react';
import BordereauEtatAcquittement from '../../../../../constants/liquidation/bordereaux/BordereauEtatAcquittement';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';

interface BordereauForceEtatAckModalProps {
	onChange: (data: BordereauWithState) => void;
	onClose: VoidFunction;
	isAcquittement: boolean;
	isSuperUser: boolean;
	visible: boolean;
	bordereau: BordereauWithState;
}

const BordereauForceEtatAckModal = ({
	onClose,
	onChange,
	visible,
	bordereau,
	isSuperUser,
	isAcquittement,
}: BordereauForceEtatAckModalProps) => {
	const { isValidated, validationComponent } = useModalSuperUserValidation();

	const [anomalieAck, setAnomalieAck] = React.useState<string>('');

	const handleChangeMotif = (_e: any, { value }: any): void => {
		setAnomalieAck(value);
	};

	const handleClick = (): void => {
		onChange({
			...bordereau,
			acquitte: isAcquittement
				? BordereauEtatAcquittement.ACQUITTE
				: BordereauEtatAcquittement.NON_ACQUITTE,
			...(!isAcquittement && { anomalieAck }),
		});
		onClose();
	};

	return (
		<Modal
			closeIcon
			open={visible}
			onClose={onClose}
			data-testid="bordereauForceEtatAckModal"
		>
			<Modal.Header>
				{`Considérer le bordereau n°${bordereau.numero} comme ${isAcquittement ? 'acquitté' : 'non-acquitté'}`}
			</Modal.Header>
			<Modal.Content>
				<p>
					{`Cette action irrémédiable consiste à marquer le bordereau comme ${isAcquittement ? 'acquitté' : 'non-acquitté'} par la DGFiP.
          ${
						!isAcquittement
							? ` Vous devez en avoir la preuve pour éviter des anomalies de
           doublon Hélios si vous réémettez ensuite un flux PES.`
							: ''
					}`}
				</p>
				{!isAcquittement && (
					<Form>
						<Form.Field
							key="motifNack"
							name="motifNack"
							value={anomalieAck}
							onChange={handleChangeMotif}
							control={TextArea}
							data-testid="borderauNackMotif"
							label="Motif du non-acquittement"
							placeholder="Vous devez renseigner un motif pour justifier le non-acquittement du bordereau"
							required
							rows={2}
						/>
					</Form>
				)}
				{isSuperUser && validationComponent}
			</Modal.Content>
			<Modal.Actions>
				<Button
					onClick={onClose}
					data-testid="bordereauForceEtatAckModalCancel"
				>
					Annuler
				</Button>
				<Button
					disabled={
						(isSuperUser && !isValidated) || (!anomalieAck && !isAcquittement)
					}
					primary
					onClick={handleClick}
					data-testid="bordereauForceEtatAckModalConfirm"
				>
					Confirmer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default BordereauForceEtatAckModal;
